/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths.
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.lastButtonWidth = 0;
    /** @type {ResizeObserver | undefined} */
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');
    this.zipInput = this.querySelector('.email-signup__input--zip');
    this.form = this.closest('form');

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }

    // Handle zip code submission
    if (this.form && this.zipInput) {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.form.addEventListener('submit', this.handleFormSubmit);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.form && this.handleFormSubmit) {
      this.form.removeEventListener('submit', this.handleFormSubmit);
    }
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }

  handleFormSubmit(event) {
    if (!this.zipInput || !this.form) return;

    const zipCode = this.zipInput.value.trim();
    
    // If zip code is provided, add it to the note field
    if (zipCode) {
      let noteField = this.form.querySelector('input[name="contact[note]"]');
      
      // Create note field if it doesn't exist
      if (!noteField) {
        noteField = document.createElement('input');
        noteField.type = 'hidden';
        noteField.name = 'contact[note]';
        this.form.appendChild(noteField);
      }
      
      // Set the note value to include zip code
      noteField.value = `Zip Code: ${zipCode}`;
    }
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
